<style scoped lang="less">
.statistics {
  margin-bottom: 10px;
  margin-left: 80%;

  label {
    font-weight: 600;
  }
}
</style>
<template>
  <div class="list">
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item href="#">CRM管理</Breadcrumb-item>
        <Breadcrumb-item>今日将转出名单</Breadcrumb-item>
      </Breadcrumb>
    </div>
    <div style="margin-top: 20px">
      <Form :label-width="100" :show-message="false" label-position="right">
        <Row :gutter="32">
          <Col span="6">
            <FormItem label="意向等级：">
              <Select
                v-model="queryParam.intentLevel"
                @on-change="search"
                clearable
                placeholder="不论"
              >
                <Option value="1">高意向</Option>
                <Option value="2">意向一般</Option>
                <Option value="3">待跟进</Option>
                <Option value="4">无效资源</Option>
              </Select>
            </FormItem>
          </Col>
          <Col span="6">
            <FormItem label="学员状态：">
              <Select
                v-model="queryParam.stdStatus"
                @on-change="search"
                clearable
                placeholder="不论"
              >
                <Option value="1">新注册</Option>
                <Option value="3">已预约</Option>
                <Option value="4">已试听</Option>
                <Option value="5">付款未绑定</Option>
                <Option value="6">已绑定</Option>
                <Option value="7">已开课</Option>
                <Option value="8">已完课</Option>
                <Option value="9">退费</Option>
              </Select>
            </FormItem>
          </Col>
          <Col span="6">
            <FormItem label="接通状态：">
              <Select
                v-model="queryParam.connectionStatus"
                @on-change="search"
                clearable
                placeholder="不论"
              >
                <Option value="1">未拨打</Option>
                <Option value="2">拨打未接</Option>
                <Option value="3">拨打接通</Option>
              </Select>
            </FormItem>
          </Col>
        </Row>
        <Row :gutter="32">
            <Col span="6">
              <Form-item label="学生:" :label-width="75">
                <Input placeholder="ID/手机号/姓名" name="searchKeyword"
                       v-model="queryParam.searchKeyword"></Input>
              </Form-item>
            </Col>
            <Col span="8">
            <Form-item label="注册日期:">
              <Col span="11">
                <Date-picker
                  type="datetime"
                  format="yyyy-MM-dd"
                  placeholder="请选择日期"
                  @on-change="regTimeStartChange"
                  :value="queryParam.regStartTimeDate"
                  style="width: 100%;"
                ></Date-picker>
              </Col>
              <Col span="1" style="text-align: center"> -</Col>
              <Col span="11">
                <Date-picker
                  type="datetime"
                  format="yyyy-MM-dd"
                  placeholder="请选择日期"
                  @on-change="regTimeEndChange"
                  :value="queryParam.regEndTimeDate"
                  style="width: 100%;"
                ></Date-picker>
              </Col>
            </Form-item>
          </Col>
          <Col span="4">
              <Button type="primary" @click="search()">搜索</Button>
            </Col>
        </Row>
      </Form>
    </div>
    <adviser-float-modal
        :adviserId="queryParam.adviserId"
        :teamType="queryParam.teamType"
        @get_adviser="getAdviserInfo"
      ></adviser-float-modal>
<!--    <div class="export">
      <Button
        type="primary"
        @click="exportDaiyTransOut"
        :onloading="exportLoading"
      >导出</Button>
    </div>-->
    <List
      style="margin-top: 10px"
      :tableColumns="title"
      listUrl="/userinfo/dailyTransOut"
      :params="queryParam"
      :onLoading="onLoading"
      :reload="reload"
    ></List>
    <UserInfoModal
      :value="editUser"
      @on-close="closeModal"
      :uid="uid"
      :successCallback="search"
    ></UserInfoModal>
  </div>
</template>
<script>
import UserInfoModal from './UserInfoModal.vue'
import AdviserFloatModal from '../common/AdviserFloatModal.vue'

export default {
  components: {
    UserInfoModal,
    AdviserFloatModal
  },
  data () {
    let $constant = this.$constant
    return {
      searchLoading: false,
      editUser: false,
      exportLoading: false,
      reload: 0,
      url: '/userinfo/dailyTransOut',
      uid: null,
      queryParam: {
        intentLevel: '',
        stdStatus: '',
        connectionStatus: '',
        regStartTimeDate: '',
        regEndTimeDate: '',
        studentTag: null,
        bookTestId: '',
        searchKeyword: '',
        studyAdviserId: '',
        adviserId: null,
        teamType: null,
        adviserIdList: null,
      },
      studyAdvisers: [],
      title: [
        {
          title: '学生姓名/ID',
          // width: 160,
          align: 'center',
          render: (h, params) => {
            let row = params.row
            return h('span', row.uid + '-' + row.nickName)
          }
        },
        {
          title: '手机号',
          key: 'mobile',
          align: 'center',
          // width: 150,
          render: (h, params) => {
            if (params.row.mobile.startsWith('n')) {
              return h('span', '')
            }
            return h('Poptip', {
              props: {
                trigger: 'hover'
              }
            }, [
              h('span', {}, params.row.mobile.length === 11 ? params.row.mobile.substring(0, 3) +
                '****' + params.row.mobile.substring(7) : params.row.mobile),
              // 当前行展示的数据
              h('div', {slot: 'content'}, params.row.mobile)
            ])
          }
        },
        {
          title: '城市',
          // width: 130,
          align: 'center',
          render: (h, params) => {
            let province = params.row.province
            let city = params.row.city
            let address = ''
            if (province && province !== '未知') {
              address = address + province
            }
            if (city && city !== '未知') {
              address = address + city
            }
            return h('span', address)
          }
        },
        {
          title: '渠道',
          // width: 110,
          align: 'center',
          key: 'regType'
          // render: (h, params) => {
          //   let regType = params.row.regType
          //   let type = $constant.getEnum($constant.studentCanal, regType)
          //   return h('span', type && type.text)
          // }
        },
        {
          title: '注册时间',
          align: 'center',
          // width: 170,
          key: 'regTime'
        },
        {
          title: '课程顾问',
          align: 'center',
          key: 'adviserName',
          // width: 120,
        },
        {
          title: '接通状态',
          // width: 110,
          align: 'center',
          render: (h, params) => {
            let status = params.row.connectionStatus
            let typeEnum = $constant.getEnum($constant.connectionStatus, status)
            return h('span', typeEnum && typeEnum.text)
          }
        },
        {
          title: '客户意向',
          // width: 120,
          align: 'center',
          render: (h, params) => {
            let status = params.row.intentLevel
            let typeEnum = $constant.getEnum($constant.intentLevel, status)
            return h('span', typeEnum && typeEnum.text)
          }
        },
        {
          title: '学员状态',
          align: 'center',
          // width: 120,
          render: (h, params) => {
            let status = params.row.stdStatus
            let typeEnum = $constant.getEnum($constant.stdStatus, status)
            return h('span', typeEnum && typeEnum.text)
          }
        },
        {
          title: '操作',
          align: 'center',
          // width: 120,
          render: (h, params) => {
            let self = this
            let row = params.row
            return h('a', {on: {click: () => self.edit(row.uid)}}, '编辑')
          }
        },
      ],
    }
  },
  methods: {
    getAdviserInfo (obj) {
      if (obj) {
        this.queryParam.adviserId = obj.adviserId
        if (obj.adviserIds.length > 1) {
          this.queryParam.adviserId = '0'
        }
        this.queryParam.teamType = obj.teamType
        this.queryParam.adviserIdList = obj.adviserIds
      }
    },
    search () {
      this.reload = new Date().getTime()
    },
    edit (uid) {
      this.uid = uid
      this.editUser = true
    },
    closeModal (val) {
      this.editUser = val
    },
    exportDaiyTransOut () {
      this.exportLoading = true
      this.$http.get('/userinfo/exportUserInfo', {
        responseType: 'arraybuffer',
        params: this.queryParam
      }).then((response) => {
        if (response.data) {
          let blob = new Blob([response.data], {type: 'text/csv'})
          let link = document.createElement('a')
          link.target = '_blank'
          link.href = window.URL.createObjectURL(blob)
          link.download = '今日将转出名单.csv'
          link.click()
          this.exportLoading = false
        } else {
          this.$Message.error(response.msg)
        }
      }).catch((e) => {
        this.exportLoading = false
      })
    },
    onLoading (loading) {
      this.searchLoading = loading
    },
    regTimeStartChange (val) {
      this.queryParam.regStartTimeDate = val
    },
    regTimeEndChange (val) {
      this.queryParam.regEndTimeDate = val
    },
    lessonStartTimeChange (val) {
      this.queryParam.lessonStartTimeDate = val
    },
    lessonEndTimeChange (val) {
      this.queryParam.lessonEndTimeDate = val
    },
  },
  created: function () {
  },
  mounted: function () {
    let self = this
    self.$http.get('/adminUser/listByCondition?adminGroupId=' + 4).then(function (res) {
      self.studyAdvisers = res.data
    })
    this.search()
  },
}
</script>

<style>
  .export {
    display: flex;
    justify-content: end;
    margin-top: 24px;
  }
</style>



// WEBPACK FOOTER //
// DailyTransferList.vue?d716c9fc